<template>
    <div class="white-box white-box-no-tab">
        <!-- 集中檢核 -->
        <PopupCheckBDP
            v-model:postApiCheckBDP="postApiCheckBDP"
            @confirm="confirmApiCheckBDP"
            @close="isLoading = 0"
        />
        <!-- 門號核實 -->
        <ModalMobileVerify
            v-model:postApiMid="postApiMid"
            @confirm="confirmApiMid"
        />
        <h3 class="mb-2.5">
            請確認此保單資料
        </h3>
        <p class="text-base xs:text-lg text-gray-900 pb-4 border-b mb-3.5">
            即日起線上保單服務皆會發送動態密碼予您，並驗證您輸入的動態密碼正確後，才完成線上保單服務申請。
        </p>
        <EditTelAndMailInput
            v-model:validInput="validInput"
            v-model:isDisable="isDisable"
            :info="info"
            :mobileCodeList="mobileCodeList"
            :catchErrorArray="info.catchErrorArray"
            @getValidResult="getValidResult"
            @closePopup="closePopup"
            @clearError="info.catchErrorArray = []"
        />
        <div class="text-center">
            <button
                class="btn rounded-full"
                :class="[isDisable?'btn-accent':'gradient-primary']"
                :disabled="isDisable"
                @click="validInput = true"
            >
                確定
            </button>
        </div>
        <Loading :is-loading="isLoading > 0" />
        <PopupEffect v-model:visiblePopup="visiblePopup" />
    </div>
</template>

<script>
import { computed, reactive, ref, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Loading from '@/components/Loading.vue';
import PopupEffect from '@/components/dialogs/PopupEffect.vue';
import PopupCheckBDP from '@/components/dialogs/PopupCheckBDP.vue';
import ModalMobileVerify from '@/components/dialogs/ModalMobileVerify/ModalMobileVerify.vue';
import EditTelAndMailInput from './InputForm.vue';
import routeName from '@/router/constant.js';
import { getContactInfo, getMobileCodeInfo, policyOverview, selectChangedPolicy, startTransaction, submitContact } from '@/apis/system.js';
import { getNeedMIDVerify } from '@/apis/mid';

export default {
    components: {
        Loading,
        PopupCheckBDP,
        EditTelAndMailInput,
        ModalMobileVerify,
        PopupEffect,
    },
    setup() {
        const router = useRouter();
        const store = useStore();
        const aplCatl = computed(() => store.state.permissions.aplCatl);

        const validInput = ref(false);
        // const isLoading = ref(0);
        const visiblePopup = ref(false);
        const mobileCodeList = ref([]);
        const info = reactive({
            mobileCountry: '',
            mobile: '',
            email: '',
            catchErrorArray: [],
        });
        const state = reactive({
            isLoading: 0,
            postApiCheckBDP: false,
            postApiMid: false,
            isDisable: false,
        });

        const getData = () => {
            state.isLoading = 2;

            getMobileCodeInfo().then(res => {
                if (res.data) {
                    mobileCodeList.value = res.data.mobileCodeList.map(i => {
                        i.label = `${i.text}(+${i.value})`;
                        return i;
                    });
                }
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                state.isLoading--;
            });

            getContactInfo().then(res => {
                info.mobileCountry = res.data.mobileCountry;
                info.mobile = res.data.mobile;
                info.email = res.data.email;
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                state.isLoading--;
            });
        };

        getData();

        const getValidResult = (returnObj) => {
            if (returnObj.isPass) {
                goNext(returnObj.returnData);
            }
        };

        const goNext = (returnData) => {
            state.isLoading = 2;
            submitContact(returnData).then(res => {
                state.postApiCheckBDP = true;
            }).catch(error => {
                info.catchErrorArray = error.data.details;
                state.isLoading--;
            }).finally(() => {
                state.isLoading--;
            });
        };

        const confirmApiCheckBDP = () => {
            getNeedMIDVerify().then(res => {
                if (res.data.flag) {
                    state.isLoading = 0;
                    state.postApiMid = true;
                } else {
                    gotoNext();
                }
            });
        };

        const confirmApiMid = () => {
            gotoNext();
        };

        const closePopup = () => {
            // router.push({ name: routeName.HOME });
        };

        const gotoNext = () => {
            state.isLoading = 1;
            let page = '';
            switch (aplCatl.value) {
                case 'A3':
                    page = routeName.A3_SELECT_POLICY;
                    router.push({ name: page });
                    break;
                case 'A4':
                    page = routeName.A4_SET_ACCONT;
                    break;
                case 'A5':
                    page = routeName.A5_SET_ACCONT;
                    break;
                case 'A6':
                    page = routeName.A6_SELECT_POLICY;
                    router.push({ name: page });
                    break;
            }
            if (aplCatl.value === 'A3' || aplCatl.value === 'A6') {
                router.push({ name: page });
            } else {
                policyOverview(aplCatl.value).then(res => {
                    const policy = res.data?.policyList[0] || [];
                    const requestBody = {
                        policyNo: policy.policyNo,
                        policySeq: policy.policySeq,
                        idDup: policy.idDup,
                        srceFrom: policy.srceFrom,
                    };
                    selectChangedPolicy(requestBody).then(() => {
                        store.dispatch('policy/setPolicy', policy);
                        startTransaction().then(() => {
                            router.push({ name: page });
                        }).finally(() => {
                            state.isLoading--;
                        });
                    }).catch(err => {
                        console.log(err);
                        state.isLoading--;
                    }).finally(() => {
                    });
                }).catch(err => {
                    console.log(err);
                    state.isLoading--;
                }).finally(() => {
                });
            }
        };
        return {
            validInput,
            visiblePopup,
            closePopup,
            mobileCodeList,
            getValidResult,
            goNext,
            info,
            ...toRefs(state),
            confirmApiCheckBDP,
            confirmApiMid,
        };
    },
};
</script>
